module.exports = __webpack_public_path__ + "static/img/MV16.827b1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV16.jpg
// module id = WiWm
// module chunks = 0